<script setup lang="ts">
import FormProduto from '../components/form-produto.vue'
import { useProdutoStore } from '../store/useProdutoStore'

definePage({
  meta: {
    navActiveLink: 'admin-produto',
    action: 'create',
    subject: 'produto',
  },
})

const { resetForm } = useProdutoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormProduto />
</template>
